// src/pages/groups/EditGroupForm.js
import React, { useState } from 'react';
import axios from 'axios';

const EditGroupForm = ({ onClose, onGroupUpdated, groupToEdit }) => {
  // Initialize state with the existing group name
  const [groupName, setGroupName] = useState(groupToEdit.group_name);
  const API_URL = process.env.REACT_APP_API_URL;
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // PUT request to update the specific group ID
      await axios.put(`${API_URL}/ems/groups/${groupToEdit._id}`, { group_name: groupName });
      
      onGroupUpdated(); // Refresh group list (renamed prop for clarity)
      onClose();        // Close modal
    } catch (err) {
      console.error('Error editing group:', err.response?.data || err.message);
      alert('Failed to edit group');
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
      <div className="modal-dialog modal-md" role="document">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Edit Group: {groupToEdit.group_name}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Group Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-warning">Save Changes</button>
              <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditGroupForm;